<template>
  
    <!-- sdf -->
    <b-row class="pt-2">
      <b-col lg="12">
        <h3>
          <span class="bd-content-title">
            {{$t('lms.userList.systemUsers')}}
          </span>
        </h3>
      </b-col>
      <b-col lg="12" class="mt-3">
          <b-button variant="success" size="sm" class="mr-2" v-b-modal.userModal>Жана</b-button>
          <b-button variant="info" v-if="selectedRows.length==1" size="sm" @click="updateRecord" class="mr-2">Өңдеу</b-button>
          <b-button variant="danger" v-if="selectedRows.length>0" size="sm" class="mr-2" @click="deleteRecord">Жою</b-button>
      </b-col>
      <b-col lg="5">
        <b-form-group
          :label="$i18n.locale()=='kz' ? 'Іздеу' : 'Поиск'"
          label-cols-sm="1"
          label-align-sm="left"
          label-size="sm"
          label-for="filterInput"
          class="mb-2 mt-3"
        >
          <b-input-group size="sm">
            <b-form-input
              v-model="filter"
              type="search"
              id="filterInput"
              :placeholder="$i18n.locale()=='kz' ? 'Іздеу' : 'Поиск'"
            ></b-form-input>
            
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col lg="4" class="pt-3">
        <select  class="form-control text-center" v-model="roleId" @change="sysChange">
          <option :value=0>{{$t("comboChooseText")}}</option>
          <option v-for="(r,ri) in roles" :key="ri" :value="r.id">{{r.name.toUpperCase().trim()}}</option>
          
        </select>
      </b-col>
      <b-col lg="3" class="pt-3 text-right">
        <strong>
          {{$i18n.locale()=='kz' ? 'Жалпы саны:' : 'Общее число'}}
        </strong> {{totalRows}}  
      </b-col>
      <b-table 
        ref="userTable"
        striped hover selectable
        :items="userProvider" 
        :fields="fields"
        :busy.sync="isBusy"
        :current-page="currentPage"
        :per-page="perPage"
        :table-variant="tableVariant"
        :filter="filter"
        :select-mode="selectMode"
        selected-variant="danger"
      
        @row-selected="onUserSelected"
        >
        <template v-slot:cell(id)="{ rowSelected }">
          <template v-if="rowSelected">
            <span aria-hidden="true">&check;</span>
            <span class="sr-only">Selected</span>
          </template>
          <template v-else>
            <span aria-hidden="true">&nbsp;</span>
            <span class="sr-only">Not selected</span>
          </template>
        </template>
        <template v-slot:table-busy>
          <div class="text-center text-info my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Жүктелуде...</strong>
          </div>
        </template>
        <template #head(lastName)="data">
            <div class="text-left text-info my-2">{{$t(data.label)}}</div>
        </template>
        <template #head(firstName)="data">
            <div class="text-left text-info my-2">{{$t(data.label)}}</div>
        </template>
        <template #head(email)="data">
            <div class="text-left text-info my-2">{{$t(data.label)}}</div>
        </template>
        <template #head(phoneNumber)="data">
            <div class="text-left text-info my-2">{{$t(data.label)}}</div>
        </template>
        <template #head(roleName)="data">
            <div class="text-left text-info my-2">{{$t(data.label)}}</div>
        </template>
        <template #head(isActive)="data">
            <div class="text-left text-info my-2">{{$t(data.label)}}</div>
        </template>

        <template #head(enroll)="data">
            <div class="text-left text-info my-2">{{$t(data.label)}}</div>
        </template>
        <template v-slot:cell(roleName)="row">
          <b>
            {{row.item.roleName}}
          </b>
        </template>
         <!-- <template v-slot:cell(enroll)="row">
            <b-button variant="outline-primary" size="sm" @click="chooseCourse(row.item.id)">
              SELECT COURSES
            </b-button>
         </template> -->
         <template v-slot:cell(isActive)="row">
          <b-button variant="outline-danger" size="sm" @click="changeBlock(row.item.id)">
            {{row.item.isActive==1 ? $t("lms.userList.blocking") : $t("lms.userList.unblocking")}}
          </b-button>
        </template>
      </b-table>
      <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="fill"
          size="sm"
          class="my-0"
          
      ></b-pagination>

      <b-modal id="userModal" :title="$t('lms.userForm.modalTitle')" hide-footer @hidden="modalHidden">
          <b-form v-on:submit.prevent="submitUser">
                <b-form-row class="mb-3">
                    <b-col sm="auto" md="12">
                        <label for="roleId">{{$t('lms.userForm.userType')}}</label>
                        <select class="form-control text-center"
                            id="roleId"
                            v-model="userForm.roleId"  
                        >
                          <option :value=0>{{$t("comboChooseText")}}</option>
                          <option v-for="(r,ri) in roles" :key="ri" :value=r.id> == {{r.name}} == </option>
                        </select>
                    </b-col>
                    <b-col sm="auto" md="12">
                        <label for="lastName">{{$t('lms.userForm.lastName')}}</label>
                        <b-form-input
                            id="lastName"
                            v-model="userForm.lastName"
                            required
                        ></b-form-input>
                    </b-col>
                    <b-col sm="auto" md="12">
                        <label  for="firstName">{{$t('lms.userForm.firstName')}}</label>
                        <b-form-input
                            id="firstName"
                            v-model="userForm.firstName"
                            required
                        ></b-form-input>
                    </b-col>
                     <b-col sm="auto" md="12">
                        <label  for="thirdName">{{$t('lms.userForm.thirdName')}}</label>
                        <b-form-input
                            id="thirdName"
                            v-model="userForm.thirdName"
                            required
                        ></b-form-input>
                    </b-col>
                    <b-col sm="auto" md="12">
                        <label  for="userEmail">{{$t('lms.userForm.email')}}</label>
                        <input
                            class="form-control"
                            id="userEmail"
                            v-model="userForm.email"
                            type="email"
                            required
                        />
                    </b-col>
                    <b-col sm="auto" md="12">
                        <label  for="userEmail">{{$t('lms.userForm.phoneNumber')}}</label>
                        <b-form-input
                            id="userPhone"
                            v-model="userForm.phoneNumber"
                            type="Text"
                            required
                            placeholder="Телефон"
                        ></b-form-input>
                    </b-col>
                    <b-col sm="auto" md="12">
                        <label  for="password">{{$t('lms.userForm.password')}}</label>
                        <b-form-input
                            id="password"
                            v-model="userForm.password"
                            type="password"
                            required
                        ></b-form-input>
                    </b-col>
                </b-form-row>
                <b-button type="submit" variant="primary" class="mr-2">{{$t('lms.userForm.addUser')}}</b-button>
                <b-button type="reset" variant="danger">{{$t('lms.userForm.clear')}}</b-button>
            </b-form>    
      </b-modal>
     
    </b-row>

</template>

<script>
import axios from 'axios';
import {apiDomain,getHeader} from "../config/config";

import vue from 'vue';
export default {
  
  name: 'Users',
  data(){
    return {
      selectedUserId:0,
      fields: [
          {
            key: 'Id',
            label: 'Id',
          },
          {
            key: 'lastName',
            label: 'lms.userList.lastName',
          },
          {
            key: 'firstName',
            label: 'lms.userList.firstName',
          },
          {
            key: 'email',
            label: 'lms.userList.userName',
          },
          {
            key: 'phoneNumber',
            label: 'lms.userList.phoneNumber',
          },
          {
            key: 'roleName',
            label: 'lms.userList.role',
          },
          
          //  {
          //   key: 'enroll',
          //   label: 'lms.userList.enroll',
          // },
          {
            key: 'isActive',
            label: 'lms.userList.blocking',
          },
      ],
      isBusy:false,
      totalRows:0,
      currentPage: 1,
      perPage: 20,
      tableVariant:'light',
      filter:"",
      selectMode:'multi',
      selectedRows:[],

      //begining of the form submission
      userForm:{
        id:0,
        thirdName:"",
        firstName:"",
        lastName:"",
        phoneNumber:"",
        email:"",       
        password:"",
        roleId:0,
        userRoles:[]
      },

      userRoles:[{value:null,text:'Кіру рөлі'}],
      roles:[],
      roleId:0
    }
  },
  methods:{
    modalHidden(){
      this.userForm={
            id:0,
            thirdName:"",
            firstName:"",
            lastName:"",
            phoneNumber:"",
            email:"",       
            password:"",
            roleId:0,
            userRole:[]
      }
    },
    chooseCourse(userId){
      this.selectedUserId=userId;
      this.$bvModal.show("selectCourseModal")
    },
    sysChange(){
      this.$refs.userTable.refresh();  
    },
    deleteRecord(){
      let warn = confirm("Сіз сенімдісіз бе ?");
      if(warn){
        if(this.selectedRows.length>0){
          axios.post(apiDomain+'/user/delete',this.selectedRows,{headers:getHeader()})
            .then(response=>{
              //alert(response.data);
              this.$refs.userTable.refresh();  
            })
            .catch(error => {
                //console.log(error.message)
                this.$bvToast.toast(error.message, {
                    title: 'Кате',
                    autoHideDelay: 5000
                })
            }) 
        }
      }
      
    },
    updateRecord(){
      if(this.selectedRows.length==1){
       
        let Id = this.selectedRows[0].id;
        if(Id>0){
          axios.post(apiDomain+'/user/current',{id:Id},{headers:getHeader()})
          .then(response=>{
            this.userForm=response.data;

            this.$bvModal.show('userModal')    
          })
          .catch(error => {
              //console.log(error.message)
              this.$bvToast.toast(error.message, {
                  title: 'алдаа',
                  autoHideDelay: 5000
              })
          }) 
        }
      }
    },
    
    submitUser(evt){
        this.userForm.userRoles=[];
        evt.preventDefault();
        if(Number(this.userForm.roleId)==0){
          alert(vue.i18n.translate("lms.userForm.roleConfirm"));
          return 
        }
        this.userForm.userRoles.push({id:this.userForm.roleId});
        //alert(JSON.stringify(this.userForm));
        axios.post(apiDomain+'/user/create',this.userForm,{headers:getHeader()})
        .then(response=>{
          let alertMsg = "Сәтті аяқталды";
          if(response.data==='dublicated'){
            alertMsg='Пайдаланушының электрондық поштасы бұрын тіркелген.'
          }
          else{
            this.$bvModal.hide('userModal')
            this.userForm={
                  id:0,
                  thirdName:"",
                  firstName:"",
                  lastName:"",
                  phoneNumber:"",
                  email:"",       
                  password:"",
                  roleId:0,
                  userRole:[]
            }
            this.$refs.userTable.refresh()
          }
          
          this.$bvToast.toast(alertMsg, {
              title: 'Жетістік',
              autoHideDelay: 5000
          })
        })
      .catch(error => {
          //console.log(error.message)
          //alert(JSON.stringify(error))
          this.$bvToast.toast("the email has already registered !!!", {
              title: 'ERROR',
              variant:"danger",
              autoHideDelay: 5000
          })
      }) 
    },

    onUserSelected(items){
      this.selectedRows=items;
    },
    changeBlock(id){
      axios.post(apiDomain+'/user/changestatus',{userId:id},{headers:getHeader()}).then(()=>{
        this.$refs.userTable.refresh();
      });
    },
    userProvider(ctx){
        //alert("yes");
        this.isBusy = false
        ctx.roleId=this.roleId;
        let promise = axios.post(apiDomain+'/user/list',ctx,{headers:getHeader()});
        return promise.then((response) => {
          const result = response.data;
          this.isBusy = false
          this.totalRows=result.recordCount;
          //alert(JSON.stringify(result));
          return(result.items)
        }).catch(error => {
          this.isBusy = false
          return []
        })
    },
    getRefs(){
       axios.post(apiDomain+'/user/rolelist',{},{headers:getHeader()})
          .then(response=>{
              this.roles = response.data;
          })
          .catch(error => {
              //console.log(error.message)
              //alert("server dr aldaa uuslee");
          }
      ) 
    }
  },
  created(){
    this.getRefs()
  }
}
</script>